import axios from 'axios';

// API base URL - Environment variable'dan al, yoksa Railway production URL kullan
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://web-production-bdd98.up.railway.app/api';

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('stationOwnerToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - token süresi dolmuşsa logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('stationOwnerToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Station Owner API fonksiyonları
export const stationOwnerAPI: {
  login: (email: string, password: string) => Promise<any>;
  register: (data: any) => Promise<any>;
  getProfile: () => Promise<any>;
  updateProfile: (data: any) => Promise<any>;
  changePassword: (data: any) => Promise<any>;
  getDashboard: () => Promise<any>;
  getStations: () => Promise<any>;
  addStation: (data: any) => Promise<any>;
  updateStation: (id: string, data: any) => Promise<any>;
  deleteStation: (id: string) => Promise<any>;
  getCampaigns: () => Promise<any>;
  addCampaign: (data: any) => Promise<any>;
  updateCampaign: (id: string, data: any) => Promise<any>;
  deleteCampaign: (id: string) => Promise<any>;
  getPayments: () => Promise<any>;
  getPayment: (id: string) => Promise<any>;
  getStats: () => Promise<any>;
  getCustomers: (filters?: any) => Promise<any>;
  createCustomer: (data: any) => Promise<any>;
  getCustomerDetail: (id: string) => Promise<any>;
  updateCustomer: (id: string, data: any) => Promise<any>;
  deleteCustomer: (id: string) => Promise<any>;
  addLoyaltyPoints: (id: string, data: any) => Promise<any>;
  getInvoices: (filters?: any) => Promise<any>;
  createInvoice: (data: any) => Promise<any>;
  updateInvoice: (id: string, data: any) => Promise<any>;
  deleteInvoice: (id: string) => Promise<any>;
  markInvoiceAsPaid: (id: string, data: any) => Promise<any>;
  getSuppliers: (filters?: any) => Promise<any>;
  createSupplier: (data: any) => Promise<any>;
  getSupplierDetail: (id: string) => Promise<any>;
  updateSupplier: (id: string, data: any) => Promise<any>;
  deleteSupplier: (id: string) => Promise<any>;
  getSupplierOrders: (filters?: any) => Promise<any>;
  createSupplierOrder: (data: any) => Promise<any>;
  updateSupplierOrder: (id: string, data: any) => Promise<any>;
  deleteSupplierOrder: (id: string) => Promise<any>;
  getInventories: (filters?: any) => Promise<any>;
  createInventory: (data: any) => Promise<any>;
  updateInventory: (id: string, data: any) => Promise<any>;
  deleteInventory: (id: string) => Promise<any>;
  processStockTransaction: (data: any) => Promise<any>;
  getInventoryTransactions: (filters?: any) => Promise<any>;
  getStockReport: (filters?: any) => Promise<any>;
  getComplaints: (filters?: any) => Promise<any>;
  createComplaint: (data: any) => Promise<any>;
  getComplaintDetail: (id: string) => Promise<any>;
  updateComplaint: (id: string, data: any) => Promise<any>;
  deleteComplaint: (id: string) => Promise<any>;
  addComplaintNote: (id: string, note: string) => Promise<any>;
  resolveComplaint: (id: string, resolution: string) => Promise<any>;
  getComplaintStats: (filters?: any) => Promise<any>;
  getSurveys: (filters?: any) => Promise<any>;
  createSurvey: (data: any) => Promise<any>;
  getSurveyDetail: (id: string) => Promise<any>;
  updateSurvey: (id: string, data: any) => Promise<any>;
  deleteSurvey: (id: string) => Promise<any>;
  getSurveyResponses: (id: string, filters?: any) => Promise<any>;
  getSurveyAnalytics: (id: string) => Promise<any>;
  getRegionalPriceComparison: (params: any) => Promise<any>;
  getMarketAnalysis: (params: any) => Promise<any>;
  getCompetitionReport: (params: any) => Promise<any>;
  // Notification Service
  sendNotification: (data: any) => Promise<any>;
  sendBulkNotification: (data: any) => Promise<any>;
  getNotificationHistory: (params?: any) => Promise<any>;
  getNotificationStats: (params?: any) => Promise<any>;
  getNotificationTemplates: () => Promise<any>;
  // Notifications & Alerts
  getNotifications: (filters?: any) => Promise<any>;
  markNotificationAsRead: (id: string) => Promise<any>;
  markAllNotificationsAsRead: () => Promise<any>;
  deleteNotification: (id: string) => Promise<any>;
  getAlerts: (filters?: any) => Promise<any>;
  createAlert: (data: any) => Promise<any>;
  updateAlert: (id: string, data: any) => Promise<any>;
  deleteAlert: (id: string) => Promise<any>;
  checkAlerts: () => Promise<any>;
  createBackup: (data: any) => Promise<any>;
  getBackups: (params?: any) => Promise<any>;
  getBackupDetail: (id: string) => Promise<any>;
  downloadBackup: (id: string) => Promise<any>;
  restoreBackup: (id: string, data: any) => Promise<any>;
  deleteBackup: (id: string) => Promise<any>;
  updateBackupSchedule: (data: any) => Promise<any>;
  getBackupSchedule: () => Promise<any>;
  // Export Functions
  exportStationsPDF: (params?: any) => Promise<any>;
  exportStationsExcel: (params?: any) => Promise<any>;
  exportCampaignsPDF: (params?: any) => Promise<any>;
  exportCampaignsExcel: (params?: any) => Promise<any>;
  exportCustomersPDF: (params?: any) => Promise<any>;
  exportCustomersExcel: (params?: any) => Promise<any>;
  exportInvoicesPDF: (params?: any) => Promise<any>;
  exportInvoicesExcel: (params?: any) => Promise<any>;
  exportSuppliersExcel: (params?: any) => Promise<any>;
  exportInventoryExcel: (params?: any) => Promise<any>;
  exportComplaintsExcel: (params?: any) => Promise<any>;
  exportSurveysExcel: (params?: any) => Promise<any>;
  // Scheduled Reports
  getScheduledReports: () => Promise<any>;
  createScheduledReport: (data: any) => Promise<any>;
  getScheduledReportDetail: (id: string) => Promise<any>;
  updateScheduledReport: (id: string, data: any) => Promise<any>;
  deleteScheduledReport: (id: string) => Promise<any>;
  sendReportNow: (id: string) => Promise<any>;
  // Audit Logs
  getAuditLogs: (params?: any) => Promise<any>;
  getAuditLogDetail: (id: string) => Promise<any>;
  getAuditStats: () => Promise<any>;
  clearOldLogs: (days: number) => Promise<any>;
  // Payment & Subscription
  getPlanDetails: () => Promise<any>;
  getSubscription: () => Promise<any>;
  cancelSubscription: (data: any) => Promise<any>;
  createPayment: (data: any) => Promise<any>;
  getPaymentHistory: (params?: any) => Promise<any>;
  getPaymentDetail: (id: string) => Promise<any>;
  refundPayment: (id: string, data: any) => Promise<any>;
  // Mobile Integration
  registerToken: (data: any) => Promise<any>;
  unregisterToken: (data: any) => Promise<any>;
  sendPush: (data: any) => Promise<any>;
  getPushHistory: (params?: any) => Promise<any>;
  createQRCode: (data: any) => Promise<any>;
  getQRCodes: (params?: any) => Promise<any>;
  getQRCodeDetail: (id: string) => Promise<any>;
  deleteQRCode: (id: string) => Promise<any>;
  // Customer Segments
  getCustomerSegments: () => Promise<any>;
  createCustomerSegment: (data: any) => Promise<any>;
  updateCustomerSegment: (id: string, data: any) => Promise<any>;
  deleteCustomerSegment: (id: string) => Promise<any>;
  getSegmentCustomers: (segmentId: string) => Promise<any>;
  createSegmentCampaign: (segmentId: string, data: any) => Promise<any>;
  // Loyalty Program
  getLoyaltyRewards: () => Promise<any>;
  createLoyaltyReward: (data: any) => Promise<any>;
  updateLoyaltyReward: (id: string, data: any) => Promise<any>;
  deleteLoyaltyReward: (id: string) => Promise<any>;
  getLoyaltyStats: () => Promise<any>;
  // System Settings
  getSystemSettings: () => Promise<any>;
  updateSystemSettings: (data: any) => Promise<any>;
  // API Keys
  getApiKeys: () => Promise<any>;
  createApiKey: (data: any) => Promise<any>;
  deleteApiKey: (id: string) => Promise<any>;
  toggleApiKeyStatus: (id: string) => Promise<any>;
  getApiKeyStats: (id: string) => Promise<any>;
} = {
  // Giriş
  login: async (email: string, password: string) => {
    const response = await api.post('/station-owners/login', { email, password });
    return response.data;
  },

  // Kayıt
  register: async (data: any) => {
    const response = await api.post('/station-owners/register', data);
    return response.data;
  },

  // Profil
  getProfile: async () => {
    const response = await api.get('/station-owners/profile');
    return response.data;
  },

  updateProfile: async (data: any) => {
    const response = await api.put('/station-owners/profile', data);
    return response.data;
  },

  // Şifre değiştir
  changePassword: async (data: any) => {
    const response = await api.put('/station-owners/change-password', data);
    return response.data;
  },

  // Dashboard
  getDashboard: async () => {
    const response = await api.get('/station-owners/dashboard');
    return response.data;
  },

  // İstasyonlar
  getStations: async () => {
    const response = await api.get('/station-owners/stations');
    return response.data;
  },

  addStation: async (data: any) => {
    const response = await api.post('/station-owners/stations', data);
    return response.data;
  },

  updateStation: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/stations/${id}`, data);
    return response.data;
  },

  deleteStation: async (id: string) => {
    const response = await api.delete(`/station-owners/stations/${id}`);
    return response.data;
  },

  // Kampanyalar
  getCampaigns: async () => {
    const response = await api.get('/station-owners/campaigns');
    return response.data;
  },

  addCampaign: async (data: any) => {
    const response = await api.post('/station-owners/campaigns', data);
    return response.data;
  },

  updateCampaign: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/campaigns/${id}`, data);
    return response.data;
  },

  deleteCampaign: async (id: string) => {
    const response = await api.delete(`/station-owners/campaigns/${id}`);
    return response.data;
  },

  // Ödemeler
  getPayments: async () => {
    const response = await api.get('/station-owners/payments');
    return response.data;
  },

  getPayment: async (id: string) => {
    const response = await api.get(`/station-owners/payments/${id}`);
    return response.data;
  },

  // İstatistikler
  getStats: async () => {
    const response = await api.get('/station-owners/stats');
    return response.data;
  },

  // Müşteriler
  getCustomers: async (filters?: any) => {
    const response = await api.get('/station-owners/customers', { params: filters });
    return response.data;
  },
  createCustomer: async (data: any) => {
    const response = await api.post('/station-owners/customers', data);
    return response.data;
  },
  getCustomerDetail: async (id: string) => {
    const response = await api.get(`/station-owners/customers/${id}`);
    return response.data;
  },
  updateCustomer: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/customers/${id}`, data);
    return response.data;
  },
  deleteCustomer: async (id: string) => {
    const response = await api.delete(`/station-owners/customers/${id}`);
    return response.data;
  },
  addLoyaltyPoints: async (id: string, data: any) => {
    const response = await api.post(`/station-owners/customers/${id}/loyalty-points`, data);
    return response.data;
  },

  // Faturalar
  getInvoices: async (filters?: any) => {
    const response = await api.get('/station-owners/invoices', { params: filters });
    return response.data;
  },
  createInvoice: async (data: any) => {
    const response = await api.post('/station-owners/invoices', data);
    return response.data;
  },
  updateInvoice: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/invoices/${id}`, data);
    return response.data;
  },
  deleteInvoice: async (id: string) => {
    const response = await api.delete(`/station-owners/invoices/${id}`);
    return response.data;
  },
  markInvoiceAsPaid: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/invoices/${id}/paid`, data);
    return response.data;
  },

  // Tedarikçiler
  getSuppliers: async (filters?: any) => {
    const response = await api.get('/station-owners/suppliers', { params: filters });
    return response.data;
  },
  createSupplier: async (data: any) => {
    const response = await api.post('/station-owners/suppliers', data);
    return response.data;
  },
  getSupplierDetail: async (id: string) => {
    const response = await api.get(`/station-owners/suppliers/${id}`);
    return response.data;
  },
  updateSupplier: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/suppliers/${id}`, data);
    return response.data;
  },
  deleteSupplier: async (id: string) => {
    const response = await api.delete(`/station-owners/suppliers/${id}`);
    return response.data;
  },

  // Tedarikçi Siparişleri
  getSupplierOrders: async (filters?: any) => {
    const response = await api.get('/station-owners/supplier-orders', { params: filters });
    return response.data;
  },
  createSupplierOrder: async (data: any) => {
    const response = await api.post('/station-owners/supplier-orders', data);
    return response.data;
  },
  updateSupplierOrder: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/supplier-orders/${id}`, data);
    return response.data;
  },
  deleteSupplierOrder: async (id: string) => {
    const response = await api.delete(`/station-owners/supplier-orders/${id}`);
    return response.data;
  },

  // Envanter Yönetimi
  getInventories: async (filters?: any) => {
    const response = await api.get('/station-owners/inventory', { params: filters });
    return response.data;
  },
  createInventory: async (data: any) => {
    const response = await api.post('/station-owners/inventory', data);
    return response.data;
  },
  updateInventory: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/inventory/${id}`, data);
    return response.data;
  },
  deleteInventory: async (id: string) => {
    const response = await api.delete(`/station-owners/inventory/${id}`);
    return response.data;
  },
  processStockTransaction: async (data: any) => {
    const response = await api.post('/station-owners/inventory/transaction', data);
    return response.data;
  },
  getInventoryTransactions: async (filters?: any) => {
    const response = await api.get('/station-owners/inventory/transactions', { params: filters });
    return response.data;
  },
  getStockReport: async (filters?: any) => {
    const response = await api.get('/station-owners/inventory/report', { params: filters });
    return response.data;
  },

  // Müşteri Şikayetleri
  getComplaints: async (filters?: any) => {
    const response = await api.get('/station-owners/complaints', { params: filters });
    return response.data;
  },
  createComplaint: async (data: any) => {
    const response = await api.post('/station-owners/complaints', data);
    return response.data;
  },
  getComplaintDetail: async (id: string) => {
    const response = await api.get(`/station-owners/complaints/${id}`);
    return response.data;
  },
  updateComplaint: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/complaints/${id}`, data);
    return response.data;
  },
  deleteComplaint: async (id: string) => {
    const response = await api.delete(`/station-owners/complaints/${id}`);
    return response.data;
  },
  addComplaintNote: async (id: string, note: string) => {
    const response = await api.post(`/station-owners/complaints/${id}/notes`, { note });
    return response.data;
  },
  resolveComplaint: async (id: string, resolution: string) => {
    const response = await api.put(`/station-owners/complaints/${id}/resolve`, { resolution });
    return response.data;
  },
  getComplaintStats: async (filters?: any) => {
    const response = await api.get('/station-owners/complaints/stats', { params: filters });
    return response.data;
  },

  // Anket Sistemi
  getSurveys: async (filters?: any) => {
    const response = await api.get('/station-owners/surveys', { params: filters });
    return response.data;
  },
  createSurvey: async (data: any) => {
    const response = await api.post('/station-owners/surveys', data);
    return response.data;
  },
  getSurveyDetail: async (id: string) => {
    const response = await api.get(`/station-owners/surveys/${id}`);
    return response.data;
  },
  updateSurvey: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/surveys/${id}`, data);
    return response.data;
  },
  deleteSurvey: async (id: string) => {
    const response = await api.delete(`/station-owners/surveys/${id}`);
    return response.data;
  },
  getSurveyResponses: async (surveyId: string, filters?: any) => {
    const response = await api.get(`/station-owners/surveys/${surveyId}/responses`, { params: filters });
    return response.data;
  },
  getSurveyAnalytics: async (surveyId: string) => {
    const response = await api.get(`/station-owners/surveys/${surveyId}/analytics`);
    return response.data;
  },

  // Export Functions
  exportStationsPDF: async (params?: any) => {
    const response = await api.get('/station-owners/stations/export/pdf', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportStationsExcel: async (params?: any) => {
    const response = await api.get('/station-owners/stations/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportCampaignsPDF: async (params?: any) => {
    const response = await api.get('/station-owners/campaigns/export/pdf', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportCampaignsExcel: async (params?: any) => {
    const response = await api.get('/station-owners/campaigns/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportCustomersPDF: async (params?: any) => {
    const response = await api.get('/station-owners/customers/export/pdf', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportCustomersExcel: async (params?: any) => {
    const response = await api.get('/station-owners/customers/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportInvoicesPDF: async (params?: any) => {
    const response = await api.get('/station-owners/invoices/export/pdf', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportInvoicesExcel: async (params?: any) => {
    const response = await api.get('/station-owners/invoices/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportSuppliersExcel: async (params?: any) => {
    const response = await api.get('/station-owners/suppliers/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportInventoryExcel: async (params?: any) => {
    const response = await api.get('/station-owners/inventory/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportComplaintsExcel: async (params?: any) => {
    const response = await api.get('/station-owners/complaints/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  exportSurveysExcel: async (params?: any) => {
    const response = await api.get('/station-owners/surveys/export/excel', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },
  // Scheduled Reports
  getScheduledReports: async () => {
    const response = await api.get('/station-owners/scheduled-reports');
    return response.data;
  },
  createScheduledReport: async (data: any) => {
    const response = await api.post('/station-owners/scheduled-reports', data);
    return response.data;
  },
  getScheduledReportDetail: async (id: string) => {
    const response = await api.get(`/station-owners/scheduled-reports/${id}`);
    return response.data;
  },
  updateScheduledReport: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/scheduled-reports/${id}`, data);
    return response.data;
  },
  deleteScheduledReport: async (id: string) => {
    const response = await api.delete(`/station-owners/scheduled-reports/${id}`);
    return response.data;
  },
  sendReportNow: async (id: string) => {
    const response = await api.post(`/station-owners/scheduled-reports/${id}/send`);
    return response.data;
  },
  // Audit Logs
  getAuditLogs: async (params?: any) => {
    const response = await api.get('/station-owners/audit-logs', { params });
    return response.data;
  },
  getAuditLogDetail: async (id: string) => {
    const response = await api.get(`/station-owners/audit-logs/${id}`);
    return response.data;
  },
  getAuditStats: async () => {
    const response = await api.get('/station-owners/audit-logs/stats');
    return response.data;
  },
  clearOldLogs: async (days: number) => {
    const response = await api.delete('/station-owners/audit-logs/clear', { data: { days } });
    return response.data;
  },

  // Customer Segments
  getCustomerSegments: async () => {
    const response = await api.get('/station-owners/customer-segments');
    return response.data;
  },
  createCustomerSegment: async (data: any) => {
    const response = await api.post('/station-owners/customer-segments', data);
    return response.data;
  },
  updateCustomerSegment: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/customer-segments/${id}`, data);
    return response.data;
  },
  deleteCustomerSegment: async (id: string) => {
    const response = await api.delete(`/station-owners/customer-segments/${id}`);
    return response.data;
  },
  getSegmentCustomers: async (segmentId: string) => {
    const response = await api.get(`/station-owners/customer-segments/${segmentId}/customers`);
    return response.data;
  },
  createSegmentCampaign: async (segmentId: string, data: any) => {
    const response = await api.post(`/station-owners/customer-segments/${segmentId}/campaign`, data);
    return response.data;
  },

  // Loyalty Program
  getLoyaltyRewards: async () => {
    const response = await api.get('/station-owners/loyalty/rewards');
    return response.data;
  },
  createLoyaltyReward: async (data: any) => {
    const response = await api.post('/station-owners/loyalty/rewards', data);
    return response.data;
  },
  updateLoyaltyReward: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/loyalty/rewards/${id}`, data);
    return response.data;
  },
  deleteLoyaltyReward: async (id: string) => {
    const response = await api.delete(`/station-owners/loyalty/rewards/${id}`);
    return response.data;
  },
  getLoyaltyStats: async () => {
    const response = await api.get('/station-owners/loyalty/stats');
    return response.data;
  },

  // System Settings
  getSystemSettings: async () => {
    const response = await api.get('/station-owners/system-settings');
    return response.data;
  },
  updateSystemSettings: async (data: any) => {
    const response = await api.put('/station-owners/system-settings', data);
    return response.data;
  },

  // API Keys
  getApiKeys: async () => {
    const response = await api.get('/station-owners/api-keys');
    return response.data;
  },
  createApiKey: async (data: any) => {
    const response = await api.post('/station-owners/api-keys', data);
    return response.data;
  },
  deleteApiKey: async (id: string) => {
    const response = await api.delete(`/station-owners/api-keys/${id}`);
    return response.data;
  },
  toggleApiKeyStatus: async (id: string) => {
    const response = await api.put(`/station-owners/api-keys/${id}/toggle`);
    return response.data;
  },
  getApiKeyStats: async (id: string) => {
    const response = await api.get(`/station-owners/api-keys/${id}/stats`);
    return response.data;
  },

  // Rekabet Analizi - Bölgesel Fiyat Karşılaştırması
  getRegionalPriceComparison: async (params: {
    stationId: string;
    radius?: number;
    fuelType?: string;
  }) => {
    const response = await api.get('/station-owners/competition/regional-comparison', { params });
    return response.data;
  },

  // Rekabet Analizi - Pazar Analizi
  getMarketAnalysis: async (params?: {
    startDate?: string;
    endDate?: string;
    fuelType?: string;
    region?: string;
  }) => {
    const response = await api.get('/station-owners/competition/market-analysis', { params });
    return response.data;
  },

  // Rekabet Analizi - Rekabet Raporu
  getCompetitionReport: async (params: {
    stationId: string;
    fuelType?: string;
    radius?: number;
  }) => {
    const response = await api.get('/station-owners/competition/report', { params });
    return response.data;
  },

  // Notification Service - Email/SMS
  sendNotification: async (data: any) => {
    const response = await api.post('/station-owners/notifications/send', data);
    return response.data;
  },
  sendBulkNotification: async (data: any) => {
    const response = await api.post('/station-owners/notifications/send-bulk', data);
    return response.data;
  },
  getNotificationHistory: async (params?: any) => {
    const response = await api.get('/station-owners/notifications/history', { params });
    return response.data;
  },
  getNotificationStats: async (params?: any) => {
    const response = await api.get('/station-owners/notifications/stats', { params });
    return response.data;
  },
  getNotificationTemplates: async () => {
    const response = await api.get('/station-owners/notifications/templates');
    return response.data;
  },

  // Notifications & Alerts
  getNotifications: async (filters?: any) => {
    const response = await api.get('/station-owners/notifications', { params: filters });
    return response.data;
  },
  markNotificationAsRead: async (id: string) => {
    const response = await api.put(`/station-owners/notifications/${id}/read`);
    return response.data;
  },
  markAllNotificationsAsRead: async () => {
    const response = await api.put('/station-owners/notifications/read-all');
    return response.data;
  },
  deleteNotification: async (id: string) => {
    const response = await api.delete(`/station-owners/notifications/${id}`);
    return response.data;
  },
  getAlerts: async (filters?: any) => {
    const response = await api.get('/station-owners/alerts', { params: filters });
    return response.data;
  },
  createAlert: async (data: any) => {
    const response = await api.post('/station-owners/alerts', data);
    return response.data;
  },
  updateAlert: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/alerts/${id}`, data);
    return response.data;
  },
  deleteAlert: async (id: string) => {
    const response = await api.delete(`/station-owners/alerts/${id}`);
    return response.data;
  },
  checkAlerts: async () => {
    const response = await api.post('/station-owners/alerts/check');
    return response.data;
  },

  // Backup & Restore
  createBackup: async (data: any) => {
    const response = await api.post('/station-owners/backups', data);
    return response.data;
  },
  getBackups: async (params?: any) => {
    const response = await api.get('/station-owners/backups', { params });
    return response.data;
  },
  getBackupDetail: async (id: string) => {
    const response = await api.get(`/station-owners/backups/${id}`);
    return response.data;
  },
  downloadBackup: async (id: string) => {
    const response = await api.get(`/station-owners/backups/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },
  restoreBackup: async (id: string, data: any) => {
    const response = await api.post(`/station-owners/backups/${id}/restore`, data);
    return response.data;
  },
  deleteBackup: async (id: string) => {
    const response = await api.delete(`/station-owners/backups/${id}`);
    return response.data;
  },
  updateBackupSchedule: async (data: any) => {
    const response = await api.put('/station-owners/backups/schedule', data);
    return response.data;
  },
  getBackupSchedule: async () => {
    const response = await api.get('/station-owners/backups/schedule');
    return response.data;
  },

  // Payment & Subscription
  getPlanDetails: async () => {
    const response = await api.get('/station-owners/plans');
    return response.data;
  },
  getSubscription: async () => {
    const response = await api.get('/station-owners/subscription');
    return response.data;
  },
  cancelSubscription: async (data: any) => {
    const response = await api.post('/station-owners/subscription/cancel', data);
    return response.data;
  },
  createPayment: async (data: any) => {
    const response = await api.post('/station-owners/payments/create', data);
    return response.data;
  },
  getPaymentHistory: async (params?: any) => {
    const response = await api.get('/station-owners/payments/history', { params });
    return response.data;
  },
  getPaymentDetail: async (id: string) => {
    const response = await api.get(`/station-owners/payments/${id}`);
    return response.data;
  },
  refundPayment: async (id: string, data: any) => {
    const response = await api.post(`/station-owners/payments/${id}/refund`, data);
    return response.data;
  },

  // Mobile Integration
  registerToken: async (data: any) => {
    const response = await api.post('/station-owners/mobile/register-token', data);
    return response.data;
  },
  unregisterToken: async (data: any) => {
    const response = await api.post('/station-owners/mobile/unregister-token', data);
    return response.data;
  },
  sendPush: async (data: any) => {
    const response = await api.post('/station-owners/mobile/send-push', data);
    return response.data;
  },
  getPushHistory: async (params?: any) => {
    const response = await api.get('/station-owners/mobile/push-history', { params });
    return response.data;
  },
  createQRCode: async (data: any) => {
    const response = await api.post('/station-owners/mobile/qr-codes', data);
    return response.data;
  },
  getQRCodes: async (params?: any) => {
    const response = await api.get('/station-owners/mobile/qr-codes', { params });
    return response.data;
  },
  getQRCodeDetail: async (id: string) => {
    const response = await api.get(`/station-owners/mobile/qr-codes/${id}`);
    return response.data;
  },
  deleteQRCode: async (id: string) => {
    const response = await api.delete(`/station-owners/mobile/qr-codes/${id}`);
    return response.data;
  }
};

// Analytics API fonksiyonları
export const analyticsAPI = {
  // İstasyon performans analizi
  getStationPerformance: async (stationId: string, startDate?: string, endDate?: string) => {
    const params: any = { stationId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await api.get('/station-owners/analytics/station-performance', { params });
    return response.data;
  },

  // Kampanya ROI analizi
  getCampaignROI: async (campaignId: string) => {
    const response = await api.get(`/station-owners/analytics/campaign-roi/${campaignId}`);
    return response.data;
  },

  // Gelir raporu
  getRevenueReport: async (startDate?: string, endDate?: string, groupBy: string = 'day') => {
    const params: any = { groupBy };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await api.get('/station-owners/analytics/revenue-report', { params });
    return response.data;
  },

  // Müşteri analizi
  getCustomerAnalytics: async () => {
    const response = await api.get('/station-owners/analytics/customer-analytics');
    return response.data;
  }
};

// Veri Girişi API fonksiyonları
export const dataEntryAPI = {
  // Yakıt Fiyatları
  getFuelPrices: async (stationId?: string) => {
    const params = stationId ? { stationId } : {};
    const response = await api.get('/station-owners/fuel-prices', { params });
    return response.data;
  },
  addFuelPrice: async (data: any) => {
    const response = await api.post('/station-owners/fuel-prices', data);
    return response.data;
  },

  // EV Şarj Fiyatları
  getEVChargingPrices: async (stationId?: string) => {
    const params = stationId ? { stationId } : {};
    const response = await api.get('/station-owners/ev-charging-prices', { params });
    return response.data;
  },
  addEVChargingPrice: async (data: any) => {
    const response = await api.post('/station-owners/ev-charging-prices', data);
    return response.data;
  },

  // Stok Yönetimi
  getStocks: async (stationId?: string, productType?: string) => {
    const params: any = {};
    if (stationId) params.stationId = stationId;
    if (productType) params.productType = productType;
    const response = await api.get('/station-owners/stocks', { params });
    return response.data;
  },
  addStock: async (data: any) => {
    const response = await api.post('/station-owners/stocks', data);
    return response.data;
  },
  updateStock: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/stocks/${id}`, data);
    return response.data;
  },

  // İşlemler (Gelir/Gider)
  getTransactions: async (filters?: any) => {
    const response = await api.get('/station-owners/transactions', { params: filters });
    return response.data;
  },
  addTransaction: async (data: any) => {
    const response = await api.post('/station-owners/transactions', data);
    return response.data;
  },
  updateTransaction: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/transactions/${id}`, data);
    return response.data;
  },
  deleteTransaction: async (id: string) => {
    const response = await api.delete(`/station-owners/transactions/${id}`);
    return response.data;
  },

  // Personel Yönetimi
  getEmployees: async (filters?: any) => {
    const response = await api.get('/station-owners/employees', { params: filters });
    return response.data;
  },
  addEmployee: async (data: any) => {
    const response = await api.post('/station-owners/employees', data);
    return response.data;
  },
  updateEmployee: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/employees/${id}`, data);
    return response.data;
  },
  deleteEmployee: async (id: string) => {
    const response = await api.delete(`/station-owners/employees/${id}`);
    return response.data;
  }
};

// Notification API fonksiyonları
export const notificationAPI = {
  getNotifications: async (filters?: any) => {
    const response = await api.get('/station-owners/notifications', { params: filters });
    return response.data;
  },
  markNotificationAsRead: async (id: string) => {
    const response = await api.put(`/station-owners/notifications/${id}/read`);
    return response.data;
  },
  markAllNotificationsAsRead: async () => {
    const response = await api.put('/station-owners/notifications/read-all');
    return response.data;
  },
  deleteNotification: async (id: string) => {
    const response = await api.delete(`/station-owners/notifications/${id}`);
    return response.data;
  },

  // Alert'ler
  getAlerts: async (filters?: any) => {
    const response = await api.get('/station-owners/alerts', { params: filters });
    return response.data;
  },
  createAlert: async (data: any) => {
    const response = await api.post('/station-owners/alerts', data);
    return response.data;
  },
  updateAlert: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/alerts/${id}`, data);
    return response.data;
  },
  deleteAlert: async (id: string) => {
    const response = await api.delete(`/station-owners/alerts/${id}`);
    return response.data;
  },
  checkAlerts: async () => {
    const response = await api.post('/station-owners/alerts/check');
    return response.data;
  }
};

// SubUser API fonksiyonları
export const subUserAPI = {
  // Giriş
  login: async (email: string, password: string) => {
    const response = await api.post('/subusers/login', { email, password });
    return response.data;
  },

  // Alt kullanıcı oluştur
  createSubUser: async (data: any) => {
    const response = await api.post('/station-owners/subusers', data);
    return response.data;
  },

  // Alt kullanıcıları listele
  getSubUsers: async () => {
    const response = await api.get('/station-owners/subusers');
    return response.data;
  },

  // Alt kullanıcı detayı
  getSubUser: async (id: string) => {
    const response = await api.get(`/station-owners/subusers/${id}`);
    return response.data;
  },

  // Alt kullanıcı güncelle
  updateSubUser: async (id: string, data: any) => {
    const response = await api.put(`/station-owners/subusers/${id}`, data);
    return response.data;
  },

  // Alt kullanıcı sil
  deleteSubUser: async (id: string) => {
    const response = await api.delete(`/station-owners/subusers/${id}`);
    return response.data;
  },

  // Alt kullanıcı durumunu değiştir
  toggleSubUserStatus: async (id: string) => {
    const response = await api.put(`/station-owners/subusers/${id}/toggle-status`);
    return response.data;
  },

  // Alt kullanıcıyı onayla
  verifySubUser: async (id: string) => {
    const response = await api.put(`/station-owners/subusers/${id}/verify`);
    return response.data;
  }
};

// Station Message API fonksiyonları
export const stationMessageAPI = {
  // Mesaj gönder
  sendMessage: async (data: any) => {
    const response = await api.post('/station-owners/messages', data);
    return response.data;
  },

  // Mesajları getir
  getMessages: async () => {
    const response = await api.get('/station-owners/messages');
    return response.data;
  },

  // Mesaj detayı
  getMessage: async (id: string) => {
    const response = await api.get(`/station-owners/messages/${id}`);
    return response.data;
  },

  // Mesaj yanıtla
  replyToMessage: async (id: string, message: string) => {
    const response = await api.post(`/station-owners/messages/${id}/reply`, { message });
    return response.data;
  },

  // Mesajı arşivle
  archiveMessage: async (id: string) => {
    const response = await api.put(`/station-owners/messages/${id}/archive`);
    return response.data;
  }
};

// Notification Service API fonksiyonları (Email/SMS)
export const notificationServiceAPI = {
  // Tekil bildirim gönder
  sendNotification: async (data: {
    recipient: string;
    type: 'email' | 'sms';
    category: string;
    subject: string;
    message: string;
    relatedData?: any;
    stationId?: string;
  }) => {
    const response = await api.post('/station-owners/notifications/send', data);
    return response.data;
  },

  // Toplu bildirim gönder
  sendBulkNotification: async (data: {
    recipients: string[];
    type: 'email' | 'sms';
    category: string;
    subject: string;
    message: string;
    relatedData?: any;
    stationId?: string;
  }) => {
    const response = await api.post('/station-owners/notifications/send-bulk', data);
    return response.data;
  },

  // Bildirim geçmişini getir
  getNotificationHistory: async (params?: {
    type?: 'email' | 'sms';
    category?: string;
    status?: 'pending' | 'sent' | 'failed' | 'delivered';
    limit?: number;
    page?: number;
  }) => {
    const response = await api.get('/station-owners/notifications/history', { params });
    return response.data;
  },

  // Bildirim istatistikleri
  getNotificationStats: async (params?: {
    startDate?: string;
    endDate?: string;
  }) => {
    const response = await api.get('/station-owners/notifications/stats', { params });
    return response.data;
  },

  // Bildirim şablonları
  getNotificationTemplates: async () => {
    const response = await api.get('/station-owners/notifications/templates');
    return response.data;
  },

  // Backup & Restore - Yedekleme ve Geri Yükleme
  // Yedekleme oluştur
  createBackup: async (data: {
    backupName?: string;
    dataTypes?: {
      stations?: boolean;
      campaigns?: boolean;
      fuelPrices?: boolean;
      stocks?: boolean;
      transactions?: boolean;
      customers?: boolean;
      invoices?: boolean;
      employees?: boolean;
      suppliers?: boolean;
      inventory?: boolean;
      settings?: boolean;
    };
  }) => {
    const response = await api.post('/station-owners/backups', data);
    return response.data;
  },

  // Yedeklemeleri listele
  getBackups: async (params?: {
    page?: number;
    limit?: number;
    status?: 'pending' | 'in_progress' | 'completed' | 'failed';
  }) => {
    const response = await api.get('/station-owners/backups', { params });
    return response.data;
  },

  // Yedekleme detayı
  getBackupDetail: async (id: string) => {
    const response = await api.get(`/station-owners/backups/${id}`);
    return response.data;
  },

  // Yedekleme indir
  downloadBackup: async (id: string) => {
    const response = await api.get(`/station-owners/backups/${id}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Yedekten geri yükle
  restoreBackup: async (id: string, data: {
    restoreTypes?: {
      stations?: boolean;
      campaigns?: boolean;
      fuelPrices?: boolean;
      stocks?: boolean;
      transactions?: boolean;
      customers?: boolean;
      invoices?: boolean;
      employees?: boolean;
      suppliers?: boolean;
      inventory?: boolean;
      settings?: boolean;
    };
    deleteExisting?: boolean;
  }) => {
    const response = await api.post(`/station-owners/backups/${id}/restore`, data);
    return response.data;
  },

  // Yedekleme sil
  deleteBackup: async (id: string) => {
    const response = await api.delete(`/station-owners/backups/${id}`);
    return response.data;
  },

  // Otomatik yedekleme ayarlarını güncelle
  updateBackupSchedule: async (data: {
    frequency: 'daily' | 'weekly' | 'monthly';
    time: string;
    dayOfWeek?: number;
    dayOfMonth?: number;
  }) => {
    const response = await api.put('/station-owners/backups/schedule', { schedule: data });
    return response.data;
  },

  // Otomatik yedekleme durumunu al
  getBackupSchedule: async () => {
    const response = await api.get('/station-owners/backups/schedule');
    return response.data;
  },

  // Mobile Integration
  registerToken: async (data: any) => {
    const response = await api.post('/station-owners/mobile/register-token', data);
    return response.data;
  },
  unregisterToken: async (data: any) => {
    const response = await api.post('/station-owners/mobile/unregister-token', data);
    return response.data;
  },
  sendPush: async (data: any) => {
    const response = await api.post('/station-owners/mobile/send-push', data);
    return response.data;
  },
  getPushHistory: async (params?: any) => {
    const response = await api.get('/station-owners/mobile/push-history', { params });
    return response.data;
  },
  createQRCode: async (data: any) => {
    const response = await api.post('/station-owners/mobile/qr-codes', data);
    return response.data;
  },
  getQRCodes: async (params?: any) => {
    const response = await api.get('/station-owners/mobile/qr-codes', { params });
    return response.data;
  },
  getQRCodeDetail: async (id: string) => {
    const response = await api.get(`/station-owners/mobile/qr-codes/${id}`);
    return response.data;
  },
  deleteQRCode: async (id: string) => {
    const response = await api.delete(`/station-owners/mobile/qr-codes/${id}`);
    return response.data;
  }
};

export default api;
